<div class="text-input search-container">
  <app-label class="search-label" translationCode="SHARED.LABELS.SEARCH"></app-label>
  <div class="search-input">
    <eps-text-input [(ngModel)]="filter" (ngModelChange)="filterList($event)" labelPosition="none" [showErrors]="false" [busy]="loading"></eps-text-input>
  </div>
</div>
